import config from '@config'

import {
    EXPORTS_INIT_LOAD,
    EXPORTS_SET_LOADING_TRUE,
    EXPORTS_SET_LOADING_FALSE,
    EXPORTS_SET_LOADED_TRUE,
    EXPORTS_CREATE_PDF_TASK,
    EXPORTS_CREATE_PDF_TASK_REQUEST,
    EXPORTS_CREATE_XLS_TASK,
    EXPORTS_CREATE_XLS_TASK_REQUEST,
    EXPORTS_GET_TASK_STATUS,
    EXPORTS_GET_TASK_STATUS_REQUEST,
    EXPORTS_GET_TASK_FILE,
    EXPORTS_GET_TASK_FILE_REQUEST,
    EXPORTS_TASK_RECEIVED,
    EXPORTS_TASK_CHANGE,
    EXPORTS_TASK_REMOVE,
    EXPORTS_JOB_ADD_WATCHER,
    EXPORTS_JOB_REMOVE_WATCHER,
    EXPORTS_UPDATE_APP_STATE,
    EXPORTS_GET_TASKS_STATUS_REQUEST,
} from './constants'

export const exportsInitLoad = () => ({
    type: EXPORTS_INIT_LOAD,
})

export const exportsSetLoadingTrue = () => ({
    type: EXPORTS_SET_LOADING_TRUE,
})

export const exportsSetLoadingFalse = () => ({
    type: EXPORTS_SET_LOADING_FALSE,
})

export const exportsSetLoadedTrue = () => ({
    type: EXPORTS_SET_LOADED_TRUE,
})

export const createPdfExportTask = (module, id, settings) => ({
    type: EXPORTS_CREATE_PDF_TASK,
    data: {
        module,
        id,
        settings,
    },
})

export const createPdfExportTaskRequest = (module, entId, params, lang, token) => ({
    type: EXPORTS_CREATE_PDF_TASK_REQUEST(module, entId),
    payload: {
        ...config.api.exportBackground.createPdfBackgroundTask,
        uriParams: {
            entId,
        },
        qs: {
            ...params?.qs,
            lang,
            token,
        },
        body: params?.body,
    },
})

export const createXlsExportTask = (module, id, settings) => ({
    type: EXPORTS_CREATE_XLS_TASK,
    data: {
        module,
        id,
        settings,
    },
})

export const createXlsExportTaskRequest = (module, entId, params, lang, token) => ({
    type: EXPORTS_CREATE_XLS_TASK_REQUEST(module, entId),
    payload: {
        ...config.api.exportBackground.createXlsBackgroundTask,
        uriParams: {
            entId,
        },
        qs: {
            ...(params?.qs || {}),
            lang,
            token,
        },
        body: params?.body || {},
    },
})

export const exportsGetTaskStatus = (module, id, jobId) => ({
    type: EXPORTS_GET_TASK_STATUS,
    data: {
        module,
        id,
        jobId,
    },
})

export const exportsGetTaskStatusRequest = (jobId) => ({
    type: EXPORTS_GET_TASK_STATUS_REQUEST(jobId),
    optional: {
        retry: {
            maxTries: 3,
            delay: 5000,
        },
    },
    payload: {
        ...config.api.exportBackground.getBackgroundTaskStatus,
        uriParams: {
            jobId,
        },
    },
})

export const exportsGetTasksStatusRequest = (jobs) => ({
    type: EXPORTS_GET_TASKS_STATUS_REQUEST,
    payload: {
        ...config.api.exportBackground.getBackgroundJobsStatus,
        qs: {
            id: jobs,
        },
    },
})

export const exportsGetTaskFile = (module, id, jobId) => ({
    type: EXPORTS_GET_TASK_FILE,
    data: {
        module,
        id,
        jobId,
    },
})

export const exportsGetTaskFileRequest = (jobId, lang) => ({
    type: EXPORTS_GET_TASK_FILE_REQUEST(jobId),
    optional: {
        retry: {
            maxTries: 3,
            delay: 5000,
        },
    },
    payload: {
        ...config.api.exportBackground.getBackgroundTaskFile,
        uriParams: {
            jobId,
        },
        headers: {
            accept: 'application/octet-stream',
            contentType: 'attachment',
        },
        qs: {
            lang,
        },
    },
})

export const exportsTaskReceived = (jobId, data) => ({
    type: EXPORTS_TASK_RECEIVED,
    data: {
        jobId,
        data,
    },
})

export const exportsTaskChange = (jobId, data) => ({
    type: EXPORTS_TASK_CHANGE,
    data: {
        jobId,
        data,
    },
})

export const exportsTaskRemove = (module, entId, jobId) => ({
    type: EXPORTS_TASK_REMOVE(jobId),
    data: {
        module,
        entId,
        jobId,
    },
})

export const exportsAddWatcher = (module, entId, jobId) => ({
    type: EXPORTS_JOB_ADD_WATCHER,
    data: {
        module,
        entId,
        jobId,
    },
})

export const exportsRemoveWatcher = (module, entId, jobId) => ({
    type: EXPORTS_JOB_REMOVE_WATCHER(jobId),
    data: {
        module,
        entId,
        jobId,
    },
})

export const exportsUpdateAppState = () => ({
    type: EXPORTS_UPDATE_APP_STATE,
})
